module.exports = "pegasus_template/assets/header-fall-space-1.jpg";